import React from 'react';

const RatingQuestionBlock = ({ question, register, errors, watch }) => {
    return (
        <div className="mb-4">
            <label className="form-label d-block mb-0">
                {question.title} {question.required && "*"}
            </label>
            {question.description && (
                <p className="text-muted"><small>{question.description}</small></p>
            )}
            <div className="rating-section">
                {question.ratingType === "stars" ? (
                    <div className="star-rating">
                        {Array.from({ length: question.maxValue - question.minValue + 1 }, (_, i) => {
                            const ratingValue = i + question.minValue;
                            return (
                                <label key={ratingValue} className="star-label me-2">
                                    <input
                                        type="radio"
                                        value={ratingValue}
                                        {...register(question.internalId, {
                                            required: question.required ? `${question.title} is required` : false,
                                        })}
                                        className="d-none"
                                    />
                                    <span className="star fs-3" style={{ cursor: 'pointer' }}>
                                        {ratingValue <= (watch(question.internalId) || 0) ? '★' : '☆'}
                                    </span>
                                </label>
                            );
                        })}
                    </div>
                ) : (
                    // Numeric rating
                    <div className="numeric-rating">
                        <div className="d-flex justify-content-between mb-2">
                            <small className="text-muted">{question.minLabel || "Poor"}</small>
                            <small className="text-muted">{question.maxLabel || "Excellent"}</small>
                        </div>
                        <select
                            className="form-select"
                            {...register(question.internalId, {
                                required: question.required ? `${question.title} is required` : false,
                            })}
                        >
                            <option value="">Select a rating</option>
                            {Array.from({ length: question.maxValue - question.minValue + 1 }, (_, i) => {
                                const ratingValue = i + question.minValue;
                                return (
                                    <option key={ratingValue} value={ratingValue}>
                                        {ratingValue} {ratingValue === 1 ? 'star' : 'stars'}
                                    </option>
                                );
                            })}
                        </select>
                    </div>
                )}
            </div>
            {errors[question.internalId] && (
                <div className="text-danger small">{errors[question.internalId].message}</div>
            )}
        </div>
    );
};

export default RatingQuestionBlock;